module.exports = __webpack_public_path__ + "static/word-medical.8431b37d.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/word-medical.png
// module id = 995
// module chunks = 2